import { render, staticRenderFns } from "./PostLogItem.vue?vue&type=template&id=12f78bac&scoped=true&"
import script from "./PostLogItem.vue?vue&type=script&lang=js&"
export * from "./PostLogItem.vue?vue&type=script&lang=js&"
import style0 from "./PostLogItem.vue?vue&type=style&index=0&id=12f78bac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f78bac",
  null
  
)

export default component.exports